import { jsx as n, jsxs as l, Fragment as P } from "react/jsx-runtime";
import b, { useCallback as g } from "react";
import e from "./style.module.less.js";
import { FileIcon as E } from "./file-icon/index.js";
import I from "./file-icon/icons/download-export.svg.js";
import { ContextMenu as k } from "../../../general/context-menu/index.js";
const R = (h) => {
  var v;
  const {
    file: r,
    receiver: i,
    className: p,
    previewClassName: N,
    receiverOverlayClassName: C,
    senderOverlayClassName: f,
    fixedPositioning: s,
    toggleTimestamp: $,
    getTranslation: c
  } = h, [m, w] = b.useState(null), x = g((o) => o.replace(/(?:\r\n|\r|\n)/g, " "), []), y = g(() => {
    var u;
    const o = ((u = r.url) == null ? void 0 : u.path) ?? "";
    if (o) {
      const a = document.createElement("a");
      a.href = o, a.download = "", document.body.appendChild(a), a.click(), document.body.removeChild(a);
    } else
      console.error("File URL is missing.");
  }, [(v = r == null ? void 0 : r.url) == null ? void 0 : v.path]);
  if (!r)
    return null;
  let t = null;
  const d = /* @__PURE__ */ n(
    "div",
    {
      className: `${e.textContent} ${e.noPreviewContainer} ${i ? e.receiver : e.sender}`,
      children: /* @__PURE__ */ n("div", { className: e.noPreview, children: c("chat.no-preview") })
    }
  );
  return m ? t = d : r.mime.startsWith("image/") && r.url ? t = /* @__PURE__ */ n(
    "div",
    {
      className: `${e.fileImageContainer}
        ${i ? e.receiver : ""}`,
      children: /* @__PURE__ */ n(
        "img",
        {
          src: r.url.path,
          alt: r.name,
          className: e.fileImage,
          onError: () => w(!0)
        }
      )
    }
  ) : r.textContent ? t = /* @__PURE__ */ l(
    "div",
    {
      className: `${e.textContent} ${i ? e.receiver : e.sender}`,
      children: [
        /* @__PURE__ */ n(
          "div",
          {
            className: `${e.bgOverlay} ${i ? C : f}`
          }
        ),
        x(r.textContent)
      ]
    }
  ) : t = d, /* @__PURE__ */ l(P, { children: [
    /* @__PURE__ */ l(
      "div",
      {
        className: `
        ${e.fileName}
        ${i ? e.receiver : ""}
        ${p ?? ""}
      `,
        onClick: $,
        children: [
          /* @__PURE__ */ n(E, { file: r, className: e.icon }),
          r == null ? void 0 : r.name
        ]
      }
    ),
    !m && /* @__PURE__ */ l(
      "div",
      {
        className: `
        ${e.filePreviewContainer}
        ${i ? e.receiver : ""}
        ${N ?? ""}
      `,
        children: [
          t,
          r.url ? /* @__PURE__ */ n("div", { className: e.contextMenuContainer, children: /* @__PURE__ */ n(
            k,
            {
              items: [
                {
                  label: c("lawyer.download"),
                  onClick: () => y(),
                  icon: /* @__PURE__ */ n(I, { className: e.downloadIcon })
                }
              ],
              className: e.contextMenu,
              fixedPositioning: s,
              positioning: s ? i ? "left" : "right" : void 0
            }
          ) }) : null
        ]
      }
    )
  ] });
};
export {
  R as FilePreview
};
